import {
    getMerchantCollections,
    getMerchantCollectionsCount,
    getMerchantCollectionsList
  } from "../../services/MerchantCollections";

  export const COLLECTIONS_REQUESTS_LIST_INITIATED = "COLLECTIONS_REQUESTS_LIST_INITIATED";
  export const COLLECTIONS_REQUESTS_LIST_LOADED = "COLLECTIONS_REQUESTS_LIST_LOADED";
  export const COLLECTIONS_REQUESTS_FAILED = "COLLECTIONS_REQUESTS_FAILED";

  export const COLLECTIONS_REQUESTS_COUNT_INITIATED = "COLLECTIONS_REQUESTS_COUNT_INITIATED";
  export const COLLECTIONS_REQUESTS_COUNT_LOADED = "COLLECTIONS_REQUESTS_COUNT_LOADED";
  export const COLLECTIONS_REQUESTS_COUNT_FAILED  = "COLLECTIONS_REQUESTS_COUNT_FAILED";

  export const MERCHANT_COLLECTIONS_LIST_INITIATED = "MERCHANT_COLLECTIONS_LIST_INITIATED";
  export const MERCHANT_COLLECTIONS_LIST_LOADED = "MERCHANT_COLLECTIONS_LIST_LOADED";
  export const MERCHANT_COLLECTIONS_LIST_FAILED  = "MERCHANT_COLLECTIONS_LIST_FAILED";
  
  export const loadMerchantCollections = (getData) => {
    return (dispatch) => {
      dispatch({ type: COLLECTIONS_REQUESTS_LIST_INITIATED });
      getMerchantCollections(getData)
        .then((response) => {
          console.log('COLLECTIONS_REQUESTS_LIST_INITIATED', response.data)
          dispatch({ type: COLLECTIONS_REQUESTS_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: COLLECTIONS_REQUESTS_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantCollectionsList = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_COLLECTIONS_LIST_INITIATED });
      getMerchantCollectionsList(getData)
        .then((response) => {
          console.log('MERCHANT_COLLECTIONS_LIST_INITIATED', response.data)
          dispatch({ type: MERCHANT_COLLECTIONS_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_COLLECTIONS_LIST_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantCollectionsCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: COLLECTIONS_REQUESTS_COUNT_INITIATED });
      getMerchantCollectionsCount(getData)
        .then((response) => {
          console.log('COLLECTIONS_REQUESTS_COUNT_LOADED', response.data)
          dispatch({ type: COLLECTIONS_REQUESTS_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: COLLECTIONS_REQUESTS_COUNT_FAILED, payload: error.message });
        });
    };
  };